import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Link } from 'site-modules/shared/components/link/link';

import './research-subnav.scss';

export function ResearchSubnav({ heading, links, className, pathname, itemTrackingId }) {
  if (!links || !links.length) {
    return null;
  }

  return (
    <div className={classnames('research-subnav', className)}>
      <h2 className="heading-3 mb-1_5">{heading}</h2>
      <Row>
        {links.map(({ href, title }) => (
          <Col
            xs={6}
            className="subnav-item mb-1"
            tag={Link}
            to={href}
            key={`subnav-${title}`}
            rel={pathname === href ? 'nofollow' : undefined}
            data-tracking-id={itemTrackingId}
          >
            {title}
          </Col>
        ))}
      </Row>
    </div>
  );
}

ResearchSubnav.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string,
  pathname: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  itemTrackingId: PropTypes.string,
};

ResearchSubnav.defaultProps = {
  className: null,
  heading: null,
  pathname: null,
  links: null,
  itemTrackingId: null,
};
